import { createActions } from 'redux-actions';

import {
  CreateHealthQuoteParams,
  GetHealthQuoteParams,
  FindHealthQuoteParams,
  UpdateHealthQuoteParams,
  CustomHealthQuoteParams,
} from '@apis/HealthQuoteApi';
import { HealthQuote } from '@models/HealthQuote';
import { CreateBillingParams } from '@apis/BillingApi';

export type State = {
  healthQuote?: HealthQuote | null;
};

export type HealthQuoteFindPayload = FindHealthQuoteParams;
export type HealthQuoteCreatePayload = CreateHealthQuoteParams;
export type HealthQuoteFetchPayload = GetHealthQuoteParams;
export type HealthQuoteUpdatePayload = UpdateHealthQuoteParams;
export type HealthQuoteCustomPayload = CustomHealthQuoteParams;
export type HealthQuotePayPayload = CreateBillingParams;
export type StateUpdatePayload = Partial<State>;

export const {
  healthQuoteFind,
  healthQuoteCreate,
  healthQuoteFetch,
  healthQuoteUpdate,
  healthQuoteCustom,
  healthQuotePay,
  stateUpdate,
} = createActions(
  'HEALTH_QUOTE_FIND',
  'HEALTH_QUOTE_CREATE',
  'HEALTH_QUOTE_FETCH',
  'HEALTH_QUOTE_UPDATE',
  'HEALTH_QUOTE_CUSTOM',
  'HEALTH_QUOTE_PAY',
  'STATE_UPDATE',
  {
    prefix: 'HEALTH_QUOTE_BUY_ROUTE',
  },
);
